import { bl_del_shipment_import_file_helper_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DeliveryShipmentImportHelperContainerModel extends BaseContainerModel {
  bl_del_shipment_import_file_helper: bl_del_shipment_import_file_helper_RowClass = new bl_del_shipment_import_file_helper_RowClass();
}